// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"632":"79556e1c","820":"2d0dd833"}[chunkId] + ".chunk.css";
};